import { ACTIONS } from '../Constants';

const initialState = {
    sort: {
        collections: {
            field: 'NONE',
            order: 'NONE'
        },
        companies: {
            field: 'name',
            order: 'asc'
        },
        globalSectionItems: {
            field: 'NONE',
            order: 'NONE'
        },
        learningAssets: {
            field: 'name',
            order: 'asc'
        },
        userCollections: {
            field: 'NONE',
            order: 'NONE'
        },
        userLearningAssets: {
            field: 'NONE',
            order: 'NONE'
        },
        reviewContentItems: {
            field: 'hasComments',
            order: 'asc'
        }
    }
};

const admin = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.SORT_FIELD: {
            const { field, order, resource } = action.payload;
            const newState = { ...state };
            newState.sort[resource] = {
                field,
                order
            };
            return newState;
        }
        default:
            return state;
    }
};

export default admin;
